module.exports = __webpack_public_path__ + "assets/img/poster.635596e2.png";